import type { Student, YearGroup } from '../../types';

// Generator function for creating realistic student data
function generateStudents(yearGroupId: string, count: number, startId: number): Student[] {
  const firstNames = [
    'Oliver',
    'George',
    'Harry',
    'Jack',
    'Jacob',
    'Noah',
    'Charlie',
    'Muhammad',
    'Thomas',
    'Oscar',
    'Amelia',
    'Olivia',
    'Isla',
    'Emily',
    'Poppy',
    'Ava',
    'Isabella',
    'Jessica',
    'Lily',
    'Sophie',
  ];
  const lastNames = [
    'Smith',
    'Jones',
    'Williams',
    'Taylor',
    'Brown',
    'Davies',
    'Evans',
    'Wilson',
    'Thomas',
    'Johnson',
    'Roberts',
    'Robinson',
    'Thompson',
    'Wright',
    'Walker',
    'White',
    'Edwards',
    'Hughes',
    'Green',
    'Hall',
  ];

  const students: Student[] = [];

  for (let i = 0; i < count; i++) {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const studentId = startId + i;

    students.push({
      id: `student-${studentId}`,
      firstName,
      lastName,
      yearGroupId,
      admissionNumber: `${yearGroupId.toUpperCase()}-${String(studentId).padStart(4, '0')}`,
      classId: undefined, // Will be assigned later
      formGroupId: undefined,
      sets: [],
      bands: [],
    });
  }

  return students;
}

// Generate ~1000 students across Years 7-13
const year7Students = generateStudents('year-7', 180, 1000);
const year8Students = generateStudents('year-8', 175, 1180);
const year9Students = generateStudents('year-9', 170, 1355);
const year10Students = generateStudents('year-10', 160, 1525);
const year11Students = generateStudents('year-11', 155, 1685);
const year12Students = generateStudents('year-12', 90, 1840);
const year13Students = generateStudents('year-13', 85, 1930);

export const mockStudents: Student[] = [
  ...year7Students,
  ...year8Students,
  ...year9Students,
  ...year10Students,
  ...year11Students,
  ...year12Students,
  ...year13Students,
];

// Helper functions
export const getStudentsByYearGroup = (yearGroupId: string): Student[] => {
  return mockStudents.filter((s) => s.yearGroupId === yearGroupId);
};

export const getStudentsByClass = (classId: string): Student[] => {
  return mockStudents.filter((s) => s.classId === classId);
};

export const getStudentsByFormGroup = (formGroupId: string): Student[] => {
  return mockStudents.filter((s) => s.formGroupId === formGroupId);
};

export const getStudentsBySet = (setId: string): Student[] => {
  return mockStudents.filter((s) => s.sets.includes(setId));
};

export const getStudentById = (studentId: string): Student | undefined => {
  return mockStudents.find((s) => s.id === studentId);
};

export const getTotalStudentCount = (): number => {
  return mockStudents.length;
};

export const getStudentCountByYearGroup = (yearGroupId: string): number => {
  return getStudentsByYearGroup(yearGroupId).length;
};
